










import { Component, Vue } from 'vue-property-decorator'
import userApi from './api/userApi'
import PageHeader from '@/components/public/PageHeader.vue'
import PageFooters from '@/components/public/PageFooters.vue'
import { mapActions, mapState } from 'vuex'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN.js'

@Component({
  components: {
    PageHeader,
    PageFooters
  }
})
export default class App extends Vue {
  private locale: any = zhCN

}
